import {dataTableGroupValueStrategy} from "../../../../../services/common";

const spending2 = (currentVal, row) => {
    return {
        cash: dataTableGroupValueStrategy.arrayMoneySum('cash')(
            currentVal ? currentVal.cash : null,
            row.spending2
        ),
        cashless: dataTableGroupValueStrategy.arrayMoneySum('cashless')(
            currentVal ? currentVal.cashless : null,
            row.spending2
        ),
        total: dataTableGroupValueStrategy.arrayMoneySum('total')(
            currentVal ? currentVal.total : null,
            row.spending2
        ),
        debtCash: dataTableGroupValueStrategy.arrayMoneySum('debtCash')(
            currentVal ? currentVal.debtCash : null,
            row.spending2
        ),
        debtCashless: dataTableGroupValueStrategy.arrayMoneySum('debtCashless')(
            currentVal ? currentVal.debtCashless : null,
            row.spending2
        ),
        debtTotal: dataTableGroupValueStrategy.arrayMoneySum('debtTotal')(
            currentVal ? currentVal.debtTotal : null,
            row.spending2
        ),
        otherCash: dataTableGroupValueStrategy.arrayMoneySum('otherCash')(
            currentVal ? currentVal.otherCash : null,
            row.spending2
        ),
        otherCashless: dataTableGroupValueStrategy.arrayMoneySum('otherCashless')(
            currentVal ? currentVal.otherCashless : null,
            row.spending2
        ),
        otherTotal: dataTableGroupValueStrategy.arrayMoneySum('otherTotal')(
            currentVal ? currentVal.otherTotal : null,
            row.spending2
        ),
    };
};

export default spending2;
